import clone from 'lodash.clone';
import setWith from 'lodash.setwith';
import unset from 'lodash.unset';

declare interface SetShallowNodeValueFunction {
  <TNode extends object, TKey extends keyof TNode>(node: TNode, path: TKey, value: any): TNode;
  (node: any, path: string, value: any): any;
}

/**
 * Returns a new graph node with the value set at the path
 *
 * if value is undefined, the property is removed
 */
export const setShallowNodeValue: SetShallowNodeValueFunction = (
  node: any,
  path: string,
  value: any
) => {
  const cloned = setWith(clone(node), path, value, clone);

  // Mutate the object removing the property if value is undefined
  if (value === undefined) {
    unset(cloned, path);
  }
  return cloned;
};
